<div class="challenge-detail" [class.preview-mode]="previewMode">
  <app-header *ngIf="!previewMode"></app-header>

  <div class="challenge-detail--content challenge-detail--loading" *ngIf="loadingChallenge && !previewMode">
    <p>Loading challenge…</p>
  </div>

  <div class="challenge-detail--content" *ngIf="!loadingChallenge || previewMode">
    <app-asset-header
      [config]="headerConfig"
      [showActions]="!previewMode"
      [showLikeButton]="false"
      [showPinButton]="false"
      [showShareButton]="!previewMode"
      [shareKind]="'Challenge'"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      (bookmarkClick)="toggleChallengeBookmark()">
    </app-asset-header>

    <!-- Mobile Menu Toggle Button -->
    <button class="challenge-detail--mobile-toggle" (click)="toggleSidebar()" *ngIf="!isSidebarOpen && !previewMode">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
      <span>Manage Challenges</span>
    </button>

    <div class="challenge-detail--main">
      <div class="challenge-detail--container">
        <!-- Mobile Sidebar Overlay -->
        <div class="challenge-detail--sidebar-overlay" *ngIf="isSidebarOpen && !previewMode" (click)="closeSidebar()"></div>

        <!-- Sidebar (Offcanvas on Mobile) -->
        <aside class="challenge-detail--sidebar" [class.open]="isSidebarOpen" *ngIf="!previewMode">
        <div class="challenge-detail--sidebar-header">
          <h2>Manage Challenges</h2>
          <button class="challenge-detail--sidebar-close" (click)="closeSidebar()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
          <app-manage-challenges-sidebar [activeTab]="activeTab"></app-manage-challenges-sidebar>
          
          <!-- Challenge Timeline -->
          <app-challenge-timeline 
            *ngIf="timelineDates.start" 
            [timelineDates]="timelineDates"
            variant="sidebar"
            class="challenge-detail--timeline-sidebar"
          ></app-challenge-timeline>
          
          <!-- Prize Pool Section (Sidebar - below Timeline) -->
          <div class="challenge-detail--prize-pool-sidebar">
            <app-prize-pool [prizePool]="prizePool"></app-prize-pool>
          </div>
        </aside>
        
        <!-- Preview Mode Sidebar (Timeline and Prize Pool only) -->
        <aside class="challenge-detail--sidebar challenge-detail--sidebar-preview" *ngIf="previewMode">
          <!-- Challenge Timeline (above start icon) -->
          <app-challenge-timeline 
            *ngIf="timelineDates.start" 
            [timelineDates]="timelineDates"
            variant="sidebar"
            class="challenge-detail--timeline-sidebar"
          ></app-challenge-timeline>
          
          <!-- Prize Pool Section (Sidebar - below Timeline) -->
          <div class="challenge-detail--prize-pool-sidebar">
            <app-prize-pool [prizePool]="prizePool"></app-prize-pool>
          </div>
        </aside>
        
        <main class="challenge-detail--main-content">
          <!-- Preview mode: warning that actions are disabled -->
          <div class="challenge-detail--preview-warning" *ngIf="previewMode">
            <span class="challenge-detail--preview-warning-icon" aria-hidden="true">ℹ</span>
            <span>Clickable buttons and links are disabled for preview purpose.</span>
          </div>
          <!-- Top Sections with Image -->
          <div class="challenge-detail--top-wrapper">
            <!-- Objective and Image in Same Row -->
            <div class="challenge-detail--objective-row">
              <!-- Objective Section -->
              <div class="challenge-detail--objective-content" id="objective">
                <div class="challenge-detail--objective-text">
                  <h3 class="challenge-detail--top-section-label">{{ topSections.objective.label }}</h3>
                  <div class="challenge-detail--top-section-content" [innerHTML]="topSections.objective.content"></div>
                </div>
                <!-- Challenge Stats + HR (grouped at bottom, close together; HR aligns with image bottom) -->
                <div class="challenge-detail--objective-footer">
                  <app-challenge-stats 
                    [challengeHost]="challengeHost"
                    [participantsCount]="participantsCount"
                    [submissionsCount]="submissionsCount"
                  ></app-challenge-stats>
                  <hr class="challenge-detail--stats-divider" />
                </div>
              </div>

              <!-- Challenge Image (Right) -->
              <div class="challenge-detail--image-wrapper">
                <!-- Join Challenge / Submit Solution / Resubmit Solution / Challenge Completed Button (disabled in preview) -->
                <app-challenge-action-button
                  [hasJoinedCompetition]="hasJoinedCompetition"
                  [hasSubmittedSolution]="hasSubmittedSolution"
                  [isDrafted]="isDrafted"
                  [isDisabled]="previewMode || isJoinCompetitionDisabled || isSubmitDisabledBecauseNotStarted || isEvaluationPast"
                  [isEvaluationPast]="isEvaluationPast"
                  [isLoading]="loadingPreviousSubmission"
                  [previewMode]="previewMode"
                  (buttonClick)="!previewMode && !isEvaluationPast && (hasJoinedCompetition ? onSubmitSolution() : (!isJoinCompetitionDisabled ? onJoinChallengeClick() : null))"
                ></app-challenge-action-button>
                <p class="challenge-detail--submit-hint" *ngIf="hasJoinedCompetition && isSubmitDisabledBecauseNotStarted && submissionStartsAtFormatted">
                  Submissions will open on {{ submissionStartsAtFormatted }}
                </p>
                <!-- Image below button -->
                <div class="challenge-detail--image-container">
                  <img
                    [src]="challengeImage"
                    [alt]="challenge?.name || 'Challenge image'"
                    class="challenge-detail--image"
                    [class.challenge-detail--image-contain]="useDetailImageContain"
                    (load)="onDetailChallengeImageLoad($event)"
                  />
                </div>
              </div>
            </div>

            <!-- About the Challenge Section - Below the row -->
            <div class="challenge-detail--about-section" id="about">
              <h3 class="challenge-detail--top-section-label">{{ topSections.about.label }}</h3>
              <div class="challenge-detail--top-section-content" [innerHTML]="topSections.about.content"></div>
            </div>
          </div>

          <!-- Challenge Timeline (Mobile Only) -->
          <app-challenge-timeline 
            *ngIf="timelineDates.start" 
            [timelineDates]="timelineDates"
            variant="mobile"
            class="challenge-detail--timeline-mobile"
          ></app-challenge-timeline>

          <!-- Prize Pool Section (Mobile/Tablet) -->
          <div class="challenge-detail--prize-pool-mobile" *ngIf="prizePool.totalAmount > 0">
            <app-prize-pool [prizePool]="prizePool"></app-prize-pool>
          </div>

          <!-- Tab Navigation -->
          <app-challenge-tabs 
            [activeTab]="activeDetailTab"
            (tabChange)="onTabChange($event)"
          ></app-challenge-tabs>

          <!-- Section List -->
          <app-challenge-sections
            *ngIf="activeDetailTab === 'details'"
            [sections]="detailSections"
            [expandedSections]="expandedSections"
            (sectionToggle)="onSectionToggle($event)"
          ></app-challenge-sections>

          <!-- Rules and Guidelines Tab Content -->
          <app-challenge-rules-content
            *ngIf="activeDetailTab === 'rules'"
            [rulesPdfUrl]="rulesPdfUrl"
            [rulesPreviewUrl]="rulesPreviewUrl"
            [loadingPreview]="loadingRulesPreview"
            [disableActions]="previewMode"
            (downloadClick)="handleRulesDownload()"
            (previewClick)="handleRulesPreview()"
          ></app-challenge-rules-content>

          <!-- Dataset and Models Tab Content -->
          <app-challenge-assets-content
            *ngIf="activeDetailTab === 'data-banks'"
            [datasets]="datasets"
            [models]="models"
            [loading]="loadingDatasetsAndModels"
            [previewMode]="previewMode"
          ></app-challenge-assets-content>

        </main>
      </div>
    </div>
  </div>

  <app-footer *ngIf="!previewMode"></app-footer>

  <!-- Join Competition Terms Modal -->
  <app-modal
    [(visible)]="showJoinModal"
    header="Review Competition Terms and Conditions"
    [width]="'900px'"
    [showFooter]="true"
    [confirmLabel]="'I Understand and Accept'"
    [cancelLabel]="'Decline'"
    (onConfirm)="onJoinModalConfirm()"
    (onCancel)="onJoinModalCancel()"
  >
    <div class="challenge-detail--join-modal-content">
      <!-- Competition-Specific Rules Section -->
      <div class="challenge-detail--join-modal-section">
        <p class="challenge-detail--join-modal-intro">
          Entry in this competition constitutes your acceptance of these official competition rules.
        </p>
        <p class="challenge-detail--join-modal-text">
          This competition is a skills-based competition that promotes data science. To participate, you must register for the competition and agree to these Official Competition Rules ("Rules"), which include the Competition Website provisions and the Specific Competition Rules (collectively, the "Rules"). Please read the Rules carefully. By submitting an entry, you agree to be bound by these Rules. You may not submit an entry or be eligible to receive any prizes unless you agree to these Rules.
        </p>
      </div>

      <!-- Competition Terms and Conditions Section -->
      <div class="challenge-detail--join-modal-section">
        <h3 class="challenge-detail--join-modal-section-title">Competition terms and conditions</h3>
        
        <!-- Agreement Item 1 -->
        <div class="challenge-detail--join-modal-agreement-item">
          <div class="challenge-detail--join-modal-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <p class="challenge-detail--join-modal-agreement-text">
            I agree to the Competition-specific rules above and MahaAgX's Foundational Competition Rules. The MahaAgX Competition Foundational Rules supersede the Competition-specific rules in the event of any conflict.
          </p>
        </div>

        <!-- Agreement Item 2 -->
        <div class="challenge-detail--join-modal-agreement-item">
          <div class="challenge-detail--join-modal-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <p class="challenge-detail--join-modal-agreement-text">
            I understand joining this Competition creates a direct relationship between the Host and me. MahaAgX has no liability for any promised prizes, commitments, content, or actions of a Host or Participant.
          </p>
        </div>

        <p class="challenge-detail--join-modal-conclusion">
          By clicking "I Understand and Accept", you agree to be bound by the competition rules for <strong>{{ challenge?.name || 'this competition' }}</strong>.
        </p>
      </div>
    </div>
  </app-modal>

  <!-- Submit Solution Modal -->
  <app-modal
    [(visible)]="showSubmitModal"
    header="Submit Solution"
    [width]="'900px'"
    [showFooter]="true"
    [confirmLabel]="'Submit Solution'"
    [cancelLabel]="'Cancel'"
    [confirmButtonDisabled]="!isSubmitSolutionFormValid || !hasSubmitFormChanges"
    (onConfirm)="onSubmitSolutionConfirm()"
    (onCancel)="onSubmitSolutionCancel()"
  >
    <div class="challenge-detail--submit-modal-content challenge-detail--submit-modal-no-progress">
      <!-- Solution Name -->
      <div class="challenge-detail--submit-field">
        <label class="challenge-detail--submit-label">
          Solution Name <span class="challenge-detail--required">*</span>
        </label>
        <input
          type="text"
          class="challenge-detail--submit-input"
          [(ngModel)]="solutionName"
          placeholder="Enter solution name"
          maxlength="200"
        />
      </div>

      <!-- Solution Description -->
      <div class="challenge-detail--submit-field">
        <label class="challenge-detail--submit-label">
          Solution Description <span class="challenge-detail--required">*</span>
        </label>
        <textarea
          class="challenge-detail--submit-textarea"
          [(ngModel)]="solutionDescription"
          placeholder="Describe your solution approach, methodology, and key features..."
          rows="5"
          maxlength="2000"
        ></textarea>
        <div class="challenge-detail--submit-char-count">
          {{ solutionDescription.length }} / 2000 characters
        </div>
      </div>

      <!-- File Section: Resubmission (same layout as upload) OR new upload -->
      <div class="challenge-detail--submit-section">
        <h3 class="challenge-detail--submit-section-title">Upload Files</h3>

        <!-- Resubmission: same two-column layout as submit flow -->
        <div *ngIf="hasResubmissionAttachments" class="challenge-detail--file-upload-row">
          <!-- Solution ZIP File -->
          <div class="challenge-detail--submit-field challenge-detail--submit-field-col-6">
            <label class="challenge-detail--submit-label">
              Solution ZIP File <span class="challenge-detail--required">*</span>
            </label>
            <p class="challenge-detail--submit-hint">Upload your solution code and related files as a ZIP archive</p>
            <div class="challenge-detail--file-upload-wrapper">
              <ng-container *ngIf="resubmissionZipFile || (solutionZipFile && solutionZipObjectKey); else zipUpload">
                <div class="challenge-detail--file-upload-label challenge-detail--file-upload-success">
                  <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17 8 12 3 7 8"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                  </svg>
                  <span class="challenge-detail--file-name">{{ resubmissionZipFile?.filename ?? solutionZipFile?.name }}</span>
                  <button
                    *ngIf="!uploadingAttachment"
                    type="button"
                    class="challenge-detail--file-delete-icon"
                    (click)="resubmissionZipFile ? removePreviousSubmissionFile(resubmissionZipFile.filename) : clearSolutionZipFile(); $event.preventDefault(); $event.stopPropagation()"
                    [attr.aria-label]="'Remove file'"
                    title="Remove file"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>
                </div>
              </ng-container>
              <ng-template #zipUpload>
                <input
                  type="file"
                  id="resubmitSolutionZipFile"
                  class="challenge-detail--file-input"
                  accept=".zip,application/zip"
                  (change)="onSolutionZipFileSelected($event)"
                />
                <label for="resubmitSolutionZipFile" class="challenge-detail--file-upload-label">
                  <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17 8 12 3 7 8"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                  </svg>
                  <span>Choose ZIP File</span>
                </label>
              </ng-template>
            </div>
          </div>

          <!-- Instructions Document -->
          <div class="challenge-detail--submit-field challenge-detail--submit-field-col-6">
            <label class="challenge-detail--submit-label">
              Instructions Document <span class="challenge-detail--required">*</span>
            </label>
            <p class="challenge-detail--submit-hint challenge-detail--submit-hint-single-line">Upload a PDF or DOC file with instructions on how to run your solution</p>
            <div class="challenge-detail--file-upload-wrapper">
              <ng-container *ngIf="resubmissionInstructionsFile || (solutionInstructionsFile && solutionInstructionsObjectKey); else instructionsUpload">
                <div class="challenge-detail--file-upload-label challenge-detail--file-upload-success">
                  <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                  <span class="challenge-detail--file-name">{{ resubmissionInstructionsFile?.filename ?? solutionInstructionsFile?.name }}</span>
                  <button
                    *ngIf="!uploadingAttachment"
                    type="button"
                    class="challenge-detail--file-delete-icon"
                    (click)="resubmissionInstructionsFile ? removePreviousSubmissionFile(resubmissionInstructionsFile.filename) : clearInstructionsFile(); $event.preventDefault(); $event.stopPropagation()"
                    [attr.aria-label]="'Remove file'"
                    title="Remove file"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>
                </div>
              </ng-container>
              <ng-template #instructionsUpload>
                <input
                  type="file"
                  id="resubmitInstructionsFile"
                  class="challenge-detail--file-input"
                  accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  (change)="onInstructionsFileSelected($event)"
                />
                <label for="resubmitInstructionsFile" class="challenge-detail--file-upload-label">
                  <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                  <span>Choose PDF or DOC File</span>
                </label>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- New submission: show upload buttons -->
        <div *ngIf="!hasResubmissionAttachments" class="challenge-detail--file-upload-row">
          <!-- Solution ZIP File -->
          <div class="challenge-detail--submit-field challenge-detail--submit-field-col-6">
            <label class="challenge-detail--submit-label">
              Solution ZIP File <span class="challenge-detail--required">*</span>
            </label>
            <p class="challenge-detail--submit-hint">Upload your solution code and related files as a ZIP archive</p>
            <div class="challenge-detail--file-upload-wrapper">
              <input
                type="file"
                id="solutionZipFile"
                class="challenge-detail--file-input"
                accept=".zip,application/zip"
                (change)="onSolutionZipFileSelected($event)"
              />
              <label for="solutionZipFile" class="challenge-detail--file-upload-label" [class.challenge-detail--file-upload-success]="solutionZipFile && solutionZipObjectKey">
                <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                <span *ngIf="!solutionZipFile">Choose ZIP File</span>
                <span *ngIf="solutionZipFile" class="challenge-detail--file-name">{{ solutionZipFile.name }}</span>
                <button
                  *ngIf="solutionZipFile && !uploadingAttachment"
                  type="button"
                  class="challenge-detail--file-delete-icon"
                  (click)="clearSolutionZipFile(); $event.preventDefault(); $event.stopPropagation()"
                  aria-label="Remove file"
                  title="Remove file"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </label>
            </div>
          </div>

          <!-- Instructions File -->
          <div class="challenge-detail--submit-field challenge-detail--submit-field-col-6">
            <label class="challenge-detail--submit-label">
              Instructions Document <span class="challenge-detail--required">*</span>
            </label>
            <p class="challenge-detail--submit-hint challenge-detail--submit-hint-single-line">Upload a PDF or DOC file with instructions on how to run your solution</p>
            <div class="challenge-detail--file-upload-wrapper">
              <input
                type="file"
                id="instructionsFile"
                class="challenge-detail--file-input"
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                (change)="onInstructionsFileSelected($event)"
              />
              <label for="instructionsFile" class="challenge-detail--file-upload-label" [class.challenge-detail--file-upload-success]="solutionInstructionsFile && solutionInstructionsObjectKey">
                <svg class="challenge-detail--file-upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span *ngIf="!solutionInstructionsFile">Choose PDF or DOC File</span>
                <span *ngIf="solutionInstructionsFile" class="challenge-detail--file-name">{{ solutionInstructionsFile.name }}</span>
                <button
                  *ngIf="solutionInstructionsFile && !uploadingAttachment"
                  type="button"
                  class="challenge-detail--file-delete-icon"
                  (click)="clearInstructionsFile(); $event.preventDefault(); $event.stopPropagation()"
                  aria-label="Remove file"
                  title="Remove file"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Rules and Guidelines Preview Modal -->
  <app-modal
    [(visible)]="showRulesPreviewModal"
    header="Rules and Guidelines"
    [width]="'90vw'"
    [showFooter]="true"
    [showConfirmButton]="false"
    [showCancelButton]="true"
    cancelLabel="Close"
    (onCancel)="closeRulesPreviewModal()"
    (onClose)="closeRulesPreviewModal()"
  >
    <div class="challenge-detail--rules-preview-modal-content">
      <div *ngIf="rulesPreviewPdfLoading" class="challenge-detail--rules-preview-loading">
        Loading PDF…
      </div>
      <pdf-viewer
        *ngIf="!rulesPreviewPdfLoading && rulesPreviewModalUrl"
        [src]="rulesPreviewModalUrl"
        [render-text]="true"
        [original-size]="false"
        [show-all]="true"
        [zoom]="1"
        [autoresize]="true"
        class="challenge-detail--rules-preview-pdf-viewer"
      ></pdf-viewer>
    </div>
  </app-modal>

  <!-- Login modal when user clicks Join Challenge, Bookmark or Pin but is not logged in -->
  <app-login-modal
    *ngIf="showLoginModal"
    [visible]="showLoginModal"
    (visibleChange)="showLoginModal = $event"
  ></app-login-modal>
</div>

